import React, { useEffect, useRef } from 'react';
import '../styles/Home.scss';
import profileImage from '../images/profile.jpeg';

const Home = ({ setPage }) => {
  const skillsRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    const animatedElements = document.querySelectorAll('.animate-on-scroll');
    animatedElements.forEach((el) => observer.observe(el));

    return () => {
      animatedElements.forEach((el) => observer.unobserve(el));
    };
  }, []);
  return (
    <section className="home-section">
      <div className="hero">
        <div className="hero__avatar">
          <img src={profileImage} alt="LE THINH PHAT" />
        </div>
        <div className="hero__content">
          <h1 className="hero__title">LE THINH PHAT</h1>
          <h2 className="hero__subtitle">
            <span className="typewriter">Software Engineer</span>
          </h2>
          <div className="hero__status">
            <span className="status-indicator"></span>
            <p>Available for new opportunities</p>
          </div>
          <p className="hero__description">
            Results-driven software engineer with extensive experience in full-stack development, 
            specializing in innovative, high-performance solutions. Adept at utilizing cutting-edge 
            technologies and frameworks to solve complex problems.
          </p>
          <div className="hero__cta-container">
            <button 
              onClick={() => setPage('Projects')} 
              className="hero__cta"
            >
              View My Work
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12 5 19 12 12 19"></polyline>
              </svg>
            </button>
            <a href="/Le Thinh Phat.pdf" className="hero__cta hero__cta--secondary" target="_blank" rel="noopener noreferrer">
              Download CV
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                <polyline points="7 10 12 15 17 10"></polyline>
                <line x1="12" y1="15" x2="12" y2="3"></line>
              </svg>
            </a>
          </div>
          
          <div className="social-links">
            <a href="https://github.com/AntonyLe23" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
              </svg>
            </a>
            <a href="https://www.linkedin.com/in/phat-anthony-le-84ab0117a/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
              </svg>
            </a>
            <a href="mailto:phat.lethinh@outlook.com.vn" aria-label="Email">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                <polyline points="22,6 12,13 2,6"></polyline>
              </svg>
            </a>
          </div>
        </div>
      </div>

      <div className="skills" ref={skillsRef}>
        <h2 className="skills__title animate-on-scroll">Technical Skills</h2>
        <div className="skills__container">
          <div className="skills__category animate-on-scroll">
            <div className="skills__category-header">
              <div className="skills__icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"></path>
                </svg>
              </div>
              <h3>Programming Languages</h3>
            </div>
            <ul>
              <li>
                Java (Advanced)
                <div className="skill-level">
                  <div className="skill-level__bar" style={{width: '80%'}}></div>
                </div>
              </li>
              <li className="sub-skill">
                Spring Boot Framework
                <div className="skill-level">
                  <div className="skill-level__bar" style={{width: '70%'}}></div>
                </div>
              </li>
              <li>
                Python (Intermediate)
                <div className="skill-level">
                  <div className="skill-level__bar" style={{width: '50%'}}></div>
                </div>
              </li>
              <li>
                NodeJS (Intermediate)
                <div className="skill-level">
                  <div className="skill-level__bar" style={{width: '50%'}}></div>
                </div>
              </li>
            </ul>
          </div>
          
          <div className="skills__category animate-on-scroll">
            <div className="skills__category-header">
              <div className="skills__icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="3" y1="9" x2="21" y2="9"></line>
                  <line x1="9" y1="21" x2="9" y2="9"></line>
                </svg>
              </div>
              <h3>Web Development</h3>
            </div>
            <ul>
              <li>
                HTML5, CSS3, JavaScript
                <div className="skill-level">
                  <div className="skill-level__bar" style={{width: '85%'}}></div>
                </div>
              </li>
              <li>
                React.js
                <div className="skill-level">
                  <div className="skill-level__bar" style={{width: '80%'}}></div>
                </div>
              </li>
            </ul>
          </div>
          
          <div className="skills__category animate-on-scroll">
            <div className="skills__category-header">
              <div className="skills__icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <ellipse cx="12" cy="5" rx="9" ry="3"></ellipse>
                  <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"></path>
                  <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"></path>
                </svg>
              </div>
              <h3>Databases</h3>
            </div>
            <ul>
              <li>
                MySQL, PostgreSQL
                <div className="skill-level">
                  <div className="skill-level__bar" style={{width: '85%'}}></div>
                </div>
              </li>
              <li>
                MongoDB, Elasticsearch
                <div className="skill-level">
                  <div className="skill-level__bar" style={{width: '80%'}}></div>
                </div>
              </li>
              <li>
                DataBrick
                <div className="skill-level">
                  <div className="skill-level__bar" style={{width: '75%'}}></div>
                </div>
              </li>
            </ul>
          </div>
          
          <div className="skills__category animate-on-scroll">
            <div className="skills__category-header">
              <div className="skills__icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M17 16.74a7 7 0 1 0-10 0"></path>
                  <path d="M12 20a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"></path>
                  <path d="M18 8c0 1-1 2-2 2s-2-1-2-2 1-2 2-2 2 1 2 2z"></path>
                  <path d="M6 8c0 1 1 2 2 2s2-1 2-2-1-2-2-2-2 1-2 2z"></path>
                </svg>
              </div>
              <h3>Cloud & DevOps</h3>
            </div>
            <ul>
              <li>
                AWS (ECS, Lambda, DynamoDB, Step Function, CodePipeline)
                <div className="skill-level">
                  <div className="skill-level__bar" style={{width: '85%'}}></div>
                </div>
              </li>
              <li>
                Docker, Kubernetes (K8S), Rancher
                <div className="skill-level">
                  <div className="skill-level__bar" style={{width: '30%'}}></div>
                </div>
              </li>
            </ul>
          </div>
          
          <div className="skills__category animate-on-scroll">
            <div className="skills__category-header">
              <div className="skills__icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="18" cy="18" r="3"></circle>
                  <circle cx="6" cy="6" r="3"></circle>
                  <path d="M6 21V9a9 9 0 0 0 9 9"></path>
                </svg>
              </div>
              <h3>Version Control</h3>
            </div>
            <ul>
              <li>
                Git, GitHub, GitLab
                <div className="skill-level">
                  <div className="skill-level__bar" style={{width: '70%'}}></div>
                </div>
              </li>
            </ul>
          </div>
          
          <div className="skills__category animate-on-scroll">
            <div className="skills__category-header">
              <div className="skills__icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 11l3 3L22 4"></path>
                  <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
                </svg>
              </div>
              <h3>Project & Task Management</h3>
            </div>
            <ul>
              <li>
                Jira, Trello
                <div className="skill-level">
                  <div className="skill-level__bar" style={{width: '85%'}}></div>
                </div>
              </li>
            </ul>
          </div>
          
          <div className="skills__category animate-on-scroll">
            <h3>Monitoring & Logging</h3>
            <ul>
              <li>
                Sentry, Kibana, DataDog
                <div className="skill-level">
                  <div className="skill-level__bar" style={{width: '80%'}}></div>
                </div>
              </li>
            </ul>
          </div>
          
          <div className="skills__category animate-on-scroll">
            <h3>Operating Systems</h3>
            <ul>
              <li>
                Linux, macOS, Windows
                <div className="skill-level">
                  <div className="skill-level__bar" style={{width: '70%'}}></div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      
      <div className="explore-more">
        <h3>Explore More</h3>
        <div className="explore-buttons">
          <button onClick={() => setPage('About')} className="explore-btn">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="8" x2="12" y2="16"></line>
              <line x1="8" y1="12" x2="16" y2="12"></line>
            </svg>
            About Me
          </button>
          <button onClick={() => setPage('Projects')} className="explore-btn">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
              <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
            </svg>
            Projects
          </button>
          <button onClick={() => setPage('Contact')} className="explore-btn">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
              <polyline points="22,6 12,13 2,6"></polyline>
            </svg>
            Contact
          </button>
        </div>
      </div>
    </section>
  );
};

export default Home;
